module.exports = __webpack_public_path__ + "img/patlan.259a1b36.png";